import React, { useState } from "react";
import {
  ModalContainer,
  ModalText,
  ModalInput,
  ConfirmBtn,
  CancelBtn,
  BtnContainer,
  InputNum,
} from "./modalWallet.styles";
import { Modal } from "antd";
import NumberPicker from "../numberPicker/numberPicker.component";
import { toPersianNum, toSeperatedNum, toEnglishNum } from "../../assets/utils";
import { socketServer } from "../../assets/socketConnection";
import "../../app/App.css";
import "./test.css";
const ModalWallet = ({ visible, setVisible, selectUserInfo }) => {
  const [amount, setAmount] = useState();
  const [pickerSelectedAmount, setPickerSelectedAmount] = useState(20000);
  const handleCancel = () => {
    setVisible(false);
  };
  const IncreaseAmount = () => {
    console.log();
    window.location.replace(
      `${socketServer}deposit?amount=${
        amount ? toEnglishNum(amount) : pickerSelectedAmount
      }&mem_id=${selectUserInfo}`
    );
  };

  return (
    <div>
      <Modal
        footer={null}
        closable={false}
        visible={visible}
        onCancel={handleCancel}
      >
        <ModalText>مبلغ مورد نظر را انتخاب نمایید</ModalText>

        <NumberPicker setPickerSelectedAmount={setPickerSelectedAmount} />


        <ModalInput>
          <InputNum
            type="text"
            value={toPersianNum(amount)}
            onChange={(e) => setAmount(e.target.value)}
          />
          تومان
        </ModalInput>
        <ModalText>و یا مبلغ دلخواه را وارد کنید</ModalText>
        <BtnContainer>
          <CancelBtn onClick={handleCancel}>لغو</CancelBtn>
          <ConfirmBtn onClick={IncreaseAmount}>تایید</ConfirmBtn>
        </BtnContainer>
      </Modal>
    </div>
  );
};

export default ModalWallet;
